<template>
	<div>
    <div class="popup_high_right sms-settings-popup"
         :class="['level-'+level,{}]">
      <Loading v-show="loading"/>

	    <a @click="closePopup" v-if="!level" class="close_popup_btn">
		    <inline-svg :src="require('@/assets/img/popup_close.svg')"/>
	    </a>

            <div class="popup-container scroll">
	            <div class="layout-row flex-none">
		            <h3 class="title" >
			            <back-btn v-if="level" class="back-btn" @click="$emit('close')" />
			            SMS settings
			            <span></span>
		            </h3>
	            </div>

	            <div class="flex-none layout-row flex-center top-up-area">
		            <div class="layout-column margin-r-15">
			            <span class="label" style="line-height: 150%">Balance</span>
			            <span class="balance" :class="{'red':smsAccount.balance<=3}">
				            ${{ formatMoney(parseFloat((smsAccount.balance||'0')+'').toFixed(2)) }}</span>
		            </div>
		            <div class="layout-column margin-rl-20">
			            <span class="label" style="line-height: 150%">Last 30 days SMS</span>
			            <span class="balance-wrapper"><span class="balance">{{ smsAccount.period_sms_sent||'0' }} </span> messages</span>
		            </div>
		            <div class="layout-column margin-rl-20">
			            <span class="label" style="line-height: 150%">Last 30 days usage</span>
			            <span class="balance">${{ formatMoney(parseFloat((smsAccount.period_usage||'0')+'').toFixed(2)) }}</span>
		            </div>
		            <div class="flex "></div>
		            <v-button class="create-btn" label="Top up" slim @click="topupOpen=true"/>
	            </div>

	            <div class="layout-column">
		            <div class="layout-column margin-b-10 margin-t-25">
			            <label class="headline margin-b-10">Sending phone number</label>
			            <span style="line-height: 150%;margin-right: 160px">
				            Select an SMS number below to be used to send SMS messages to your
				            contacts through funnel automations.
				            This can be different in each funnel.
			            </span>
			            <div class="layout-row flex flex-center margin-t-10">
				            <v-select class="small flex margin-r-15"
				                      :options="numbers"
				                      label="friendly_name" :reduce="x=>x.id"
				                      v-model="selectedSmsNumberId"
				                      :searchable="false" :clearable="false"
				                      small @input="changed=true"
				                      append-to-body>
					            <template v-slot:option="option">
						            <div class="flex layout-row">
							            <div class="flex layout-column">
								            <span style="font-weight: 500">{{option.friendly_name}}</span>
								            <div class="flex"></div>
								            <span style="opacity: 0.8">{{ price(option.price) }}</span>
							            </div>

							            <div class="flex-none layout-column">
								            <span class="number-worldwide-tag" v-if="!option.country">Worldwide</span>
								            <country-flag class="number-country-tag" v-else size="normal" :country="option.country" />
							            </div>
						            </div>
					            </template>
					            <template v-slot:selected-option="option">
						            <div class="flex layout-row flex-center">
							            <div class="flex layout-column">
								            <span style="font-weight: 500">{{option.friendly_name}}</span>
							            </div>

							            <div class="flex-none layout-column">
								            <span class="number-worldwide-tag" v-if="!option.country">Worldwide</span>
								            <country-flag class="number-country-tag" v-else size="normal" :country="option.country" />
							            </div>
						            </div>
					            </template>
				            </v-select>

				            <v-button label="Buy a new number" disabled slim border @click="buyNumberOpen=true" />
			            </div>
		            </div>

	            </div>

	            <div class="flex-none layout-row flex-center margin-b-10">
		            <v-button is-link :right-icon="require('@/assets/img/arrow-right.svg')"
		                      class="create-btn" flat label="SMS sending prices" slim @click="smsPricesOpen=true"/>
	            </div>

	            <div style="min-height: 50px"></div>
            </div>

	    <div class="popup-actions layout-row">
		    <v-button label="Save changes" @click="save()" :loading="saving" :disabled="!changed" />
		    <v-button label="Close" border @click="$emit('close')" />
	    </div>

    </div>

		<popup-backdrop v-if="smsPricesOpen" @close="smsPricesOpen=false">
			<sms-prices-popup :level="level+1" @close="smsPricesOpen=false"
			                  @done="smsPricesOpen=false" :funnel-id="funnel.id" />
		</popup-backdrop>
		<popup-backdrop v-if="buyNumberOpen" @close="buyNumberOpen=false">
			<buy-number-list-popup :level="level+1" @close="buyNumberOpen=false"
			                  @done="buyNumberOpen=false;load()" :funnel-id="funnel.id" />
		</popup-backdrop>
		<popup-backdrop v-if="topupOpen" @close="topupOpen=false">
			<topup-popup :level="level+1" @close="topupOpen=false" :sms-account="smsAccount"
			                  @done="topupOpen=false;load()" :funnel-id="funnel.id" />
		</popup-backdrop>



	</div>
</template>

<script>
import API from "@/api"
import Tooltip from "@/components/Tooltip.vue"
import Loading from "@/components/Loading.vue"
import VButton from "@/components/base/v-button";
import InfoIcon from "@/components/base/info-icon";
import InputField from "@/components/base/input-field";
import SelectField from "@/components/base/select-field";
import numbers from "@/helpers/numbers";
import PopupBackdrop from "@/components/base/popup-backdrop";
import BackBtn from "@/components/base/back-btn";
import SmsNumberEntry from "@/views/funnels/funnel-plus/funnel/sms_numbers/sms_number_entry";
import SmsPricesPopup from "@/views/funnels/funnel-plus/funnel/sms_numbers/sms_prices_popup";
import TopupPopup from "@/views/funnels/funnel-plus/funnel/sms_numbers/topup_popup";
import BuyNumberListPopup from "@/views/funnels/funnel-plus/funnel/sms_numbers/buy_number_list_popup";
import CountryFlag from 'vue-country-flag'
import {mapGetters} from "vuex";

export default {
	name: "SmsSettingsPopup",
	title: "SMS Settings | Funnelish™",
	mixins: [API],
	components: {
		CountryFlag,
		BuyNumberListPopup,
		TopupPopup,
		SmsPricesPopup,
		SmsNumberEntry,
		BackBtn,
		PopupBackdrop,
		SelectField,
		InputField,
		InfoIcon,
		VButton,
		Tooltip,
		Loading
	},
	props:{
		level: {
			type: Number,
			default: 0,
		},
		funnel: {
			default: null,
		},
	},
	data() {
		return {
			smsAccount:{
				balance:0,
			},
			changed: false,
			numbers:[{id:0,friendly_name:'Dynamic phone number',tag:'Free'}],
			topupOpen: false,
			smsPricesOpen:false,
			buyNumberOpen:false,
			saving: false,
			loading: false,
			funnelSmsNumberId: 0,
			selectedSmsNumberId: 0,

		}
	},
	computed:{
		...mapGetters(['setFunnelStore'])
	},
	methods: {
		formatMoney(x) {
			return numbers.numberWithCommas(x||0)
		},

		closePopup() {
			this.$emit('close')
		},
		price(p) {
			return !p ? 'Free' : `$${parseFloat(p+'').toFixed(2)}/mo`;
		},
		//API
		async load() {
			try {
				this.loading = true;
				this.smsAccount = {};
				this.numbers = [{id:0,friendly_name:'Dynamic phone number',price:0}];

				this.smsAccount = await this.api.sms.getSmsAccount();
				let newNumbers = await this.api.sms.getAll();
				this.numbers.push(...newNumbers)

			} catch (e) {
				this.$error(e);
			} finally {
				this.changed = false;
				this.loading = false;
			}
		},
		async save() {
			try {
				this.saving = true;
				let number = this.numbers.find(x=>x.id===this.selectedSmsNumberId)

				let r = await this.api.sms.updateFunnelSmsNumber(this.funnel.id, {
					number:number?number.phone_number : '',
					id:this.selectedSmsNumberId,
				});
				if (!r || r.error) {
					this.$error(r)
					return
				}
				this.funnel.sms_number_id=this.selectedSmsNumberId;
				this.$emit('done')
			} catch (e) {
				this.$error(e);
			} finally {
				this.changed = false;
				this.saving = false;
			}
		},
	},
	created() {
		this.selectedSmsNumberId = this.funnel.sms_number_id || 0;
		this.load();
	},
}
</script>
<style lang="scss">
.number-worldwide-tag {
	background: $light-silver;
	color: $dark-grey;
	border-radius: 20px;
	font-size: 12px;
	padding: 2px 10px;
	margin: auto;
}
.flag.normal-flag.number-country-tag {
	margin: auto;
	transform: scale(0.4);
}
</style>
<style lang="scss" scoped>
.sms-settings-popup {
	padding: 0;
	.create-btn {
		min-width: auto;
		white-space: nowrap;
	}
	.headline {
		font-size: 16px;
		font-weight: 500;
	}
	.top-up-area {
		border: 1px solid $light-grey;
		background: $light-silver;
		padding: 10px 15px;
		margin-right: 10px;
		margin-bottom: 20px;
		margin-top: 10px;
		border-radius: 3px;
		.label {
		}
	}
	.balance {
		margin-top: 8px;
		font-weight: bold;
		font-size: 18px;
		&.red {
			color: $light-red;
		}
	}
	.balance-wrapper {
		margin-top: 8px;
	}
	.popup-actions {
		padding: 10px 30px;
		border-top: 1px solid $light-grey;
		.button {
			margin-right: 25px;
		}
	}
	&.level-1 {
		max-width: 580px;
		box-shadow: -5px 0 20px 15px rgba(0, 0, 0, 0.10);
	}
	&.level-2 {
		max-width: 560px;
		box-shadow: -5px 0 20px 15px rgba(0, 0, 0, 0.05);
	}
	.title {
		display: flex;
		flex-direction: column;
		align-items: start;
		position: relative;
		.back-btn {
			position: absolute;
			top: -30px;
		}
	}

	.popup_high_right {
		padding: 0;
	}
	.title {
		font-size: 22px;
		line-height: 150%;
		font-weight: 600;
		letter-spacing: 0.02em;
		color: #252A32;
		margin-bottom: 5px;
		background: white;
		min-height: 40px;
	}
	.popup-container {
		display: flex;
		flex-direction: column;
		flex: 1;
		padding: 35px 30px 20px;
	}
}
.popup_title {
	font-size: 20px;
}
</style>
